export const MessagesRels = {
    getMessages: 'getMessages',
    getMessageGroups: 'getMessageGroups',
    getMessage: 'getMessage',
    createMessage: 'createMessage',
    updateMessage: 'updateMessage',
    publishMessage: 'publishMessage',
    unpublishMessage: 'unpublishMessage',
    publishMessageGroup: 'publishMessageGroup',
    unpublishMessageGroup: 'unpublishMessageGroup',
    getMessageCategories: 'getMessageCategoryTemplates',
    getMessageTemplates: 'getMessageTemplates',
    getServiceJourneys: 'getServiceJourneys'
};
